import { ProductImage } from "../picking-shared/PickingScreen";
import { groupBarcode } from "../picking-shared/barcodeFormat";
import "./put-away-shared.css";

interface Props {
    title: string | null;
    barcode: string;
    thumbnailUrl: string | null;
    imageUrl: string | null;
}

const ScannedItemCard = ({ title, barcode, thumbnailUrl, imageUrl }: Props) => (
    <div className="pa-scanned-item">
        <ProductImage thumbnailUrl={thumbnailUrl} imageUrl={imageUrl} />
        <div className="pa-scanned-item-body">
            {title && <div className="pa-scanned-item-title">{title}</div>}
            <div className="pa-scanned-item-barcode">{groupBarcode(barcode)}</div>
        </div>
    </div>
);

export default ScannedItemCard;
